import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../../services/authService';

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await authService.login(formData.email, formData.password);
      navigate('/admin/campaigns');
    } catch (error) {
      setError(error.response?.data?.error || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen relative" style={{
      backgroundImage: 'url("/gage road.jpg")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundAttachment: 'fixed'
    }}>
      {/* Logo - positioned on background */}
      <div className="absolute top-4 right-4 sm:top-4 sm:right-4 z-10">
        <div className="bg-white rounded-2xl sm:rounded-3xl px-4 py-3 sm:px-6 sm:py-4 shadow-lg">
          <img
            src="/logo.png"
            alt="Logo"
            className="h-10 sm:h-14 w-auto"
          />
        </div>
      </div>

      {/* Main Container with padding */}
      <div className="min-h-screen p-4 sm:p-6 flex items-center justify-center">
        <div className="relative w-full max-w-md">
          <div className="relative rounded-[2rem] overflow-hidden shadow-2xl bg-white">
            {/* Wave pattern background */}
            <div className="absolute inset-0">
              <svg className="absolute inset-0 w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
                <defs>
                  <mask id="loginWaveMask">
                    <rect x="0" y="0" width="100" height="100" fill="white" />
                    <path
                      d="M 75 0 
                         Q 70 12.5, 75 25
                         T 75 50
                         Q 70 62.5, 75 75
                         T 75 100
                         L 0 100
                         L 0 0
                         Z"
                      fill="black"
                    />
                  </mask>
                </defs>
                
                {/* Light teal background for entire card */}
                <rect x="0" y="0" width="100" height="100" fill="#1e4b45" />
                
                {/* Dark green left side with wave edge */}
                <rect x="0" y="0" width="100" height="100" fill="#133634" mask="url(#loginWaveMask)" />
              </svg>
            </div>

            {/* Content */}
            <div className="relative p-8 sm:p-12">
              <div className="text-center mb-6 sm:mb-8">
                <h1 className="text-xl sm:text-2xl font-bold text-white mb-3 sm:mb-4">
                  Good Drink Promotional Campaign
                </h1>
                <p className="text-white/80 text-xs sm:text-sm">
                  Sign in to your account
                </p>
              </div>

              <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
                {error && (
                  <div className="bg-red-100 border border-red-400 text-red-700 px-3 py-2 sm:px-4 sm:py-3 rounded-xl text-xs sm:text-sm">
                    {error}
                  </div>
                )}

                <div>
                  <label htmlFor="email" className="block text-xs sm:text-sm font-medium text-white mb-1 sm:mb-2">
                    Email address
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-3 py-2 sm:px-4 sm:py-3 bg-white/20 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:ring-2 focus:ring-white/50 focus:border-transparent backdrop-blur-sm text-sm sm:text-base"
                    placeholder="Enter your email"
                  />
                </div>

                <div>
                  <label htmlFor="password" className="block text-xs sm:text-sm font-medium text-white mb-1 sm:mb-2">
                    Password
                  </label>
                  <input
                    id="password"
                    name="password"
                    type="password"
                    autoComplete="current-password"
                    required
                    value={formData.password}
                    onChange={handleChange}
                    className="w-full px-3 py-2 sm:px-4 sm:py-3 bg-white/20 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:ring-2 focus:ring-white/50 focus:border-transparent backdrop-blur-sm text-sm sm:text-base"
                    placeholder="Enter your password"
                  />
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className={`w-full py-2.5 sm:py-3 px-4 text-xs sm:text-sm font-medium rounded-xl border transition-all duration-300 ${
                    loading
                      ? 'bg-white/20 text-white/50 border-white/20 cursor-not-allowed'
                      : 'bg-white text-[#133634] border-white hover:bg-white/90'
                  }`}
                >
                  {loading ? (
                    <span className="flex items-center justify-center">
                      <svg className="animate-spin -ml-1 mr-2 sm:mr-3 h-4 w-4 sm:h-5 sm:w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Signing in...
                    </span>
                  ) : (
                    'SIGN IN'
                  )}
                </button>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;